import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom'; // или используйте вашу систему роутинга
import { useAuthStore } from '../../store/useAuthStore3';

export const GoogleAuthCallback: React.FC = () => {
  const handleGoogleCallback = useAuthStore((state) => state.handleGoogleCallback);
  const error = useAuthStore((state) => state.error);
  const isLoading = useAuthStore((state) => state.isLoading);
  const navigate = useNavigate();
  
  // Флаг предотвращения дублирования запросов
  const isProcessing = useRef(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');

    if (code && !isProcessing.current) {
      isProcessing.current = true;

      handleGoogleCallback(code)
        .then(() => {
          console.log('[Google Auth] Успешно авторизован через стор');
          // Очищаем URL параметры из строки браузера и редиректим на главную/дашборд
          navigate('/', { replace: true });
        })
        .catch((err) => {
          console.error('[Google Auth] Ошибка при обработке кода:', err);
          // В случае ошибки возвращаем пользователя на экран логина
          navigate('/', { replace: true });
        });
    }
  }, [handleGoogleCallback, navigate]);

  if (isLoading) {
    return <div>Авторизация через Google... Пожалуйста, подождите.</div>;
  }

  if (error) {
    return <div style={{ color: 'red' }}>Ошибка авторизации: {error}</div>;
  }

  return null;
};